import React from 'react';
import { type MotionProps, motion } from 'framer-motion';
import { Button, type ButtonProperties } from '@/components/ui/button';

interface MotionButtonProperties
  extends MotionProps,
    Omit<
      ButtonProperties,
      | 'style'
      | 'children'
      | 'onDragEnd'
      | 'onDrag'
      | 'onDragStart'
      | 'onAnimationStart'
    > {}

const MotionButton = React.forwardRef<
  HTMLButtonElement,
  MotionButtonProperties
>(({ children, ...properties }, ref) => {
  const MotionComponent = motion.create(Button);

  return (
    <MotionComponent ref={ref} {...properties}>
      {children}
    </MotionComponent>
  );
});

export default MotionButton;
